<!-- Access Pending -->
<ng-container *ngIf="isAccessPendingNotification()">
    <div class="notification" (click)="openVessel()">
        <p class="text-wrapper">
            <a class="bold">{{ notification.userName }} </a>
            {{ 'notification.access-request.pending' | translate }}
            <a class="vessel">{{ notification.vesselNumber }} - {{ notification.vesselName }}</a>
        </p>
        <div class="udpated">
            {{ getUpdatedTime() }}
        </div>
        <div class="button-close" (click)="closeAccessNotification(); $event.stopPropagation()">
            <div>{{ 'dlg.notification.close-button' | translate }}</div>
            <mat-icon svgIcon="close-circle" class="icon" />
        </div>
    </div>
</ng-container>

<!-- Guest Editing -->
<ng-container *ngIf="isGuestEditingNotification()">
    <div class="notification" (click)="openVessel()">
        <p class="text-wrapper">
            <a class="bold">{{ notification.userName }} </a>
            {{ 'notification.access-request.editing' | translate }}
            <a class="vessel">{{ notification.vesselName }}</a>
        </p>
        <div class="udpated">
            {{ getUpdatedTime() }}
        </div>
        <div class="button-close" (click)="closeAccessNotification(); $event.stopPropagation()">
            <div>{{ 'dlg.notification.close-button' | translate }}</div>
            <mat-icon svgIcon="close-circle" class="icon" />
        </div>
    </div>
</ng-container>

<!-- Access Granted -->
<ng-container *ngIf="isAccessGrantedNotification()">
    <div class="notification" (click)="openVessel()">
        <p class="text-wrapper">
            <a class="bold">{{ notification.ownerName }} </a>
            {{ 'notification.access-request.accepted' | translate }}
            <a class="vessel">{{ notification.vesselName }}</a>
        </p>
        <div class="udpated">
            {{ getUpdatedTime() }}
        </div>
        <div class="button-close" (click)="closeAccessNotification(); $event.stopPropagation()">
            <div>{{ 'dlg.notification.close-button' | translate }}</div>
            <mat-icon svgIcon="close-circle" class="icon" />
        </div>
    </div>
</ng-container>

<!-- Access Rejected -->
<ng-container *ngIf="isAccessRejectedNotification()">
    <div class="notification" (click)="openVessel()">
        <p class="text-wrapper">
            <a class="bold">{{ notification.ownerName }} </a>
            {{ 'notification.access-request.rejected' | translate }}
            <a class="vessel">{{ notification.vesselName }}</a>
        </p>
        <div class="udpated">
            {{ getUpdatedTime() }}
        </div>
        <div class="button-close" (click)="closeAccessNotification(); $event.stopPropagation()">
            <div>{{ 'dlg.notification.close-button' | translate }}</div>
            <mat-icon svgIcon="close-circle" class="icon" />
        </div>
    </div>
</ng-container>

<!-- Access Removed -->
<ng-container *ngIf="isAccessRemovedNotification()">
    <div class="notification" (click)="openVessel()">
        <p class="text-wrapper">
            {{ 'notification.access-request.removed' | translate }}
            <a class="vessel">{{ notification.vesselName }}</a>
        </p>
        <div class="udpated">
            {{ getUpdatedTime() }}
        </div>
        <div class="button-close" (click)="closeAccessNotification(); $event.stopPropagation()">
            <div>{{ 'dlg.notification.close-button' | translate }}</div>
            <mat-icon svgIcon="close-circle" class="icon" />
        </div>
    </div>
</ng-container>

<!-- Publish Requested -->
<ng-container *ngIf="isPublishRequestedNotification()">
    <div class="notification" (click)="openVessel()">
        <p class="text-wrapper">
            {{ 'notification.publish-request.pending' | translate }}
            <a class="vessel">{{ notification.vesselName }}</a>
            {{ 'notification.publish-request.pending-2' | translate }}
        </p>
        <div class="udpated">
            {{ getUpdatedTime() }}
        </div>
        <div class="button-close" (click)="closePublishNotification(); $event.stopPropagation()">
            <div>{{ 'dlg.notification.close-button' | translate }}</div>
            <mat-icon svgIcon="close-circle" class="icon" />
        </div>
    </div>
</ng-container>

<!-- Publish Approved -->
<ng-container *ngIf="isPublishApprovedNotification()">
    <div class="notification" (click)="openVessel()">
        <p class="text-wrapper">
            <a class="bold">{{ notification.approverName }} </a>
            {{ 'notification.publish-request.accepted' | translate }}
            <a class="vessel">{{ notification.vesselName }}</a>
            {{ 'notification.publish-request.accepted-2' | translate }}
        </p>
        <div class="udpated">
            {{ getUpdatedTime() }}
        </div>
        <div class="button-close" (click)="closePublishNotification(); $event.stopPropagation()">
            <div>{{ 'dlg.notification.close-button' | translate }}</div>
            <mat-icon svgIcon="close-circle" class="icon" />
        </div>
    </div>
</ng-container>

<!-- Publish Rejected -->
<ng-container *ngIf="isPublishRejectedNotification()">
    <div class="notification" (click)="openVessel()">
        <p class="text-wrapper">
            <a class="bold">{{ notification.approverName }} </a>
            {{ 'notification.publish-request.rejected' | translate }}
            <a class="vessel">{{ notification.vesselName }}</a>
            {{ 'notification.publish-request.rejected-2' | translate }}
        </p>
        <div class="udpated">
            {{ getUpdatedTime() }}
        </div>
        <div class="button-close" (click)="closePublishNotification(); $event.stopPropagation()">
            <div>{{ 'dlg.notification.close-button' | translate }}</div>
            <mat-icon svgIcon="close-circle" class="icon" />
        </div>
    </div>
</ng-container>

<ng-container *ngIf="isHidden()">
    <div class="hidden-wrapper">
        <div>{{ 'notification.hidden.message' | translate }}</div>
        <div class="hidden-button" (click)="undoHidden()">
            {{ 'notification.hidden.button' | translate }}
        </div>
    </div>
</ng-container>
